import { Padding } from 'types';

type AddContentPaddingProps = {
  html: string;
  textPadding?: Padding;
};

export const addContentPadding = ({
  html,
  textPadding,
}: AddContentPaddingProps) => `
<html>
  <head>
    <style>
      html, body {
        margin: 0;
        padding: 0;
        height: 100%;
      }

      .page {
        width: 100%;
        height: 100%;
        position: relative;
  }

      .content {
        position: relative;
        z-index: 1;
        box-sizing: border-box;

        padding-top: ${textPadding?.top || '20mm'};
        padding-right: ${textPadding?.right || '24mm'};
        padding-bottom: ${textPadding?.bottom || '20mm'};
        padding-left: ${textPadding?.left || '24mm'};
      }
    </style>
  </head>
  <body>
    <div class="page">
      <div class="content">
        ${html}
      </div>
    </div>
  </body>
</html>
`;
